import styles from "./LoadingFallback.module.scss";

export const LoadingFallback: React.FunctionComponent = () => {
  return <div className={styles.loader} />;
};
